<template>
  <div class="col-md-12">
    <vuestic-widget :headerText="$t('management.customOs.cardTitle')">
      <form @submit.prevent="validateBeforeSubmit">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <label class="typo__label">{{$t('management.customOs.systemType')}}</label>
            <multiselect v-model="valueType" label="title" track-by="title" :options="options" :option-height="104"
                         :custom-label="customLabel" :show-labels="false">
              <template slot="singleLabel" slot-scope="props">
                <img class="option__image" :src="(props.option.img)? $data[`iconIso${props.option.img}`] : diskIconIso">
                <span class="option__title">{{ props.option.title }}</span>
              </template>
              <template slot="option" slot-scope="props">
                <img class="option__image" :src="(props.option.img)? $data[`iconIso${props.option.img}`] : diskIconIso">
                <span class="option__title">{{ props.option.title }}</span>
              </template>
            </multiselect>
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="typo__label">{{$t('management.customOs.IsoTitle')}} | <a href="#" @click="openUpload()">{{$t('management.customOs.uploadIso')}}</a></label>
            <multiselect v-model="valueIso" label="title" track-by="title"
                         :options="(isoImages !== null)? isoImages : []" :loading="isLoadinIso"
                         :option-height="104" :custom-label="customLabel" :show-labels="false">
              <template slot="singleLabel" slot-scope="props">
                  <span class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                  </span>
              </template>
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.name }}</span>
                </div>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <label class="typo__label">{{$t('management.customOs.version')}}</label>
            <multiselect v-model="valueVersion" label="title" track-by="title"
                         :options="(valueType !== null)? valueType.versions : []"
                         :option-height="104" :custom-label="customLabel" :show-labels="false">
              <template slot="singleLabel" slot-scope="props">
                  <span class="option__desc">
                    <span class="option__title">{{ props.option.label }}</span>
                  </span>
              </template>
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.label }}</span>
                </div>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="row row-action">
          <div class="col-12" v-show="showLoadBar">
            <vuestic-progress-bar size="thick" ref="hThick">
            </vuestic-progress-bar>
          </div>
          <div class="col-md-6 col-sm-6" v-show="!showLoadBar">
            <button
              type="submit"
              class="btn-sm btn btn-success"
              :disabled="valueVersion === null || valueIso == null"
            >
              {{$t('order.continue_order')}}
            </button>
          </div>
        </div>
      </form>
    </vuestic-widget>

    <vuestic-modal
      ref="uploadExistModal"
      :large="true"
      :hasFooter="true"
    >
      <div slot="title">{{'management.customOs.uploadIso' | translate}}</div>
      <CustomIsoUploadIso v-on:show="callToast($event)"/>
      <div slot="footer">
        <small>
          <button class="btn-sm btn btn-success" @click="closeUpload()">{{ $t('modal.close') }}</button>
        </small>
      </div>
    </vuestic-modal>
  </div>
</template>

<script>
  import CustomIsoUploadIso from "./CustomIsoUploadIso";
  import iconIsoDisk from '../../assets/icons/icon-disk-iso.png'
  import iconIsoMicrosft from '../../assets/icons/microsoft-iso.png'
  import iconIsoLinux from '../../assets/icons/linux-iso.png'
  import iconIsoSolarisKernel from '../../assets/icons/solaris-iso.png'
  import {getAxios} from 'services/ajax'

  export default {
    name: 'CustomIsoEditInVps',
    components: {
      CustomIsoUploadIso
    },
    props: {
      serverId: {
        type: Number,
        default: null
      },
      vmId: {
        type: Number,
        default: null
      },
    },
    data() {
      return {
        valueAnimationInterval: 3000,
        showLoadBar: false,
        iconIsoDisk: iconIsoDisk,
        iconIsoMicrosft: iconIsoMicrosft,
        iconIsoLinux: iconIsoLinux,
        iconIsoSolarisKernel: iconIsoSolarisKernel,
        valueType: null,
        valueVersion: null,
        valueIso: null,
        options: [
          {
            title: 'Microsft Windows',
            img: 'Microsft',
            versions: [
              {label: '11/2022', ostype: 'win11'},
              {label: '10/2016/2019', ostype: 'win10'},
              {label: '8.x/2012/2012r2', ostype: 'win8'},
              {label: '7/2008r2', ostype: 'win7'},
              {label: 'Vista/2008', ostype: 'w2k8'},
              {label: 'XP/2003', ostype: 'wxp'},
              {label: '2000', ostype: 'w2k'}
            ],
            show: true
          },
          {
            title: 'Linux',
            img: 'Linux',
            versions: [
              {label: '6 x 2.6 Kernel', ostype: 'l26'},
              {label: '2.4 Kernel', ostype: 'l24'}
            ],
            show: false
          },
          {
            title: 'Solaris Kernel',
            img: 'SolarisKernel',
            versions: [{label: '-', ostype: 'solaris'}]
          },
          {
            title: 'Others',
            img: 'Disk',
            versions: [{label: '-', ostype: 'other'}]
          }
        ],
        isoImages: [],
        isoImagesPrivate: [],
        isLoadinIso: false,
      }
    },
    methods: {
      validateBeforeSubmit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.formSetIsoImage()
            return;
          }
          return false;
        });
      },
      customLabel({display_name}) {
        return `${display_name}`
      },
      openUpload() {
        this.$refs.uploadExistModal.open();
      },
      closeUpload() {
        this.$refs.uploadExistModal.cancel();
      },
      collectIsoImages() {

        if (this.serverId === null){
          return false;
        }

        this.isLoadinIso = true
        this.isoImages = []

        getAxios().get('/custom_iso/' + this.serverId)
          .then(response => {
            this.isoImages.push({name: this.$t('management.customOs.selectImages.public'), $isDisabled: true})
            this.isoImages.push(...response.data.ServersIsoAction.data.public)

            this.isoImages.push({name: this.$t('management.customOs.selectImages.private'), $isDisabled: true})
            this.isoImages.push(...response.data.ServersIsoAction.data.private)

            this.isoImagesPrivate.push({name: this.$t('management.customOs.selectImages.private'), $isDisabled: true})
            this.isoImagesPrivate.push(...response.data.ServersIsoAction.data.private)
          })
          .catch(function () {
            this.showToast(this.$t('global_error.internal'), {
              icon: 'fa-exclamation',
              position: 'top-center',
              duration: 3000,
              fullWidth: false
            })
          })
          .finally(() => {
            this.isLoadinIso = false
          });
      },
      callToast(data) {
        this.collectIsoImages()

        this.showToast(this.$t(`management.customOs.${data}`), {
          icon: 'fa-exclamation',
          position: 'top-center',
          duration: 3000,
          fullWidth: false
        })
      },
      loadProgress(progress) {
        let delay = 0;

        this.$refs['hThick'].$data.valueAnimationInterval = this.valueAnimationInterval
        this.$refs['hThick'].$data.value = progress

        delay += this.valueAnimationInterval
      },
      formSetIsoImage() {
        if (this.vmId === null){
          return false;
        }

        this.showLoadBar = true
        this.loadProgress(0)

        let formData = new FormData();
        formData.append('ostype', this.valueVersion.ostype);

        getAxios().post('/custom_iso/' + this.vmId + '/' + this.valueIso.id, formData,{
          onUploadProgress: function (progressEvent) {
            this.loadProgress(parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)))
          }.bind(this)
        })
          .then(response => {
            this.showToast(this.$t(`management.customOs.${response.data.message}`), {
              icon: 'fa-exclamation',
              position: 'top-center',
              duration: 3000,
              fullWidth: false
            })

            this.$emit('reloadVmSettings', true)

            this.valueVersion = null
            this.valueType = null
            this.valueIso = null
          })
          .catch(function () {
            this.showToast(this.$t(`management.customOs.${err.response.data.message}`), {
              icon: 'fa-exclamation',
              position: 'top-center',
              duration: 3000,
              fullWidth: false
            })
          })
          .finally(() => {
            this.showLoadBar = false
          });
      },
    },
    created() {
      this.collectIsoImages()
    },
    watch: {
      valueType: function (newQuestion, oldQuestion) {
        this.valueVersion = null
      },
    }
  }
</script>

<style scoped>
  .row-action {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  small {
    font-size: 1rem;
  }

  .row {
    margin-top: 15px;
  }

  .m-t-b-sm {
    margin-bottom: 15px;
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomIso/CustomIsoEditInVps.vue